import { Asterisk } from "lucide-react";

export const Marquee = ({ items, testId = "editorial-marquee" }) => {
  const row = [...items, ...items];
  return (
    <div className="relative overflow-hidden bg-ink py-7 md:py-9 on-dark" data-testid={testId} aria-label="Industries we serve">
      <div className="flex w-max animate-marquee items-center gap-10 md:gap-14 hover:[animation-play-state:paused]">
        {row.map((t, i) => (
          <span key={i} className="flex items-center gap-10 md:gap-14 whitespace-nowrap font-display text-3xl md:text-5xl font-semibold tracking-tight" aria-hidden={i >= items.length}>
            <span className={i % 3 === 1 ? "text-transparent [-webkit-text-stroke:1px_#FAF9F6]" : "text-paper"}>{t}</span>
            <Asterisk className="h-7 w-7 md:h-9 md:w-9 text-lime" aria-hidden />
          </span>
        ))}
      </div>
    </div>
  );
};
